module.exports = __webpack_public_path__ + "static/media/susi_tuna.bec55af2.jpeg";